import { PurchaseOrderService } from "services/purchase-order-service";
import { autoinject } from "aurelia-framework";
import { I18N } from "aurelia-i18n";
import queryStringHelper from "helpers/queryStringHelper";
import routerHelper from "helpers/routerHelper";
import { DispatchProjectService } from "services/dispatch-project-service";
import notificationHelper from "helpers/notificationHelper";

@autoinject()
export default class MaterialOrder {

    public serviceType: any = "";
    public dispatchProjectCode: string = "";
    public isProjectResponsible: boolean = false;
    public readonly: boolean = false;
    public projectCode: string = "";
    public actions: { getOrders: any; } | null = null;

    constructor(private readonly i18n: I18N, private readonly purchaseOrderService: PurchaseOrderService, private readonly dispatchProjectService: DispatchProjectService) { }

    public async canActivate(params: any): Promise<any> {
        this.dispatchProjectCode = params.dispatchProjectCode;

        try {
            await this.checkIsProjectActive();
        } catch (e) {
            if (e && e.response && e.response.data && e.response.data.Exception && e.response.data.Exception.ErrorId) {
                notificationHelper.showError(this.i18n.tr(`ApiError.${e.response.data.Exception.ErrorId}`), undefined, { timeOut: 0, extendedTimeOut: 0 });
            } else {
                notificationHelper.showError(e.response.data.Exception.Message, undefined, { timeOut: 0, extendedTimeOut: 0 });
            }
            return false;
        }
        return true;
    }

    public async activate(params: any): Promise<any> {
        this.serviceType = params.serviceType;

        this.dispatchProjectCode = params.dispatchProjectCode;

        const paramsQs = routerHelper.getQuerystring(params.q);
        this.isProjectResponsible = (paramsQs && paramsQs.isProjectResponsible === "true") || false;
        if (paramsQs && paramsQs.readonly) {
            this.readonly = queryStringHelper.parseReadonly(params.q);
        }

        if (paramsQs && paramsQs.projectCode) {
            this.projectCode = paramsQs.projectCode;
        }

        this.actions = {
            getOrders: this.purchaseOrderService.GetProjectPurchaseOrders.bind(this.purchaseOrderService, this.projectCode)
        };
    }

    private async checkIsProjectActive(): Promise<void> {
        await this.dispatchProjectService.GetProjectFromDispatchProjectCode(this.dispatchProjectCode);
    }
}
